const findWeekObWithIsoWeek = (weeks, isoWeek) => weeks.find(week => week.isoWeek === isoWeek)

export default findWeekObWithIsoWeek